/* ++++++++++ --------------- IMPORTS --------------- ++++++++++ */
// libraries
import { connect } from 'react-redux';
// component
import ContentCard from 'material/embeds/contentcard/contentcard';


/* ========== ~~~~~~~~~~ EMBED : CONTENT CARD : CONTAINER ~~~~~~~~~~ ========== */
// map state
const mapStateToProps = ({ embedsState }, { contentId }) => ({
    contentUUID: embedsState.embedManagementState.contentStatus['contents'][contentId]['contentUUID'],
    selectedContent: embedsState.embedManagementState.contentStatus.selectedContent,
    contentOrder: embedsState.embedManagementState.selectedEmbedStatus.selectedEmbedData.contentOrder,
    contents:embedsState.embedManagementState.contentStatus.contents
});



/* ++++++++++ --------------- EXPORTS --------------- ++++++++++ */
export default connect(
    mapStateToProps
)(ContentCard);
